module.exports = __webpack_public_path__ + "img/antes_despues_196.b4673bf5.png";